import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { fetchCategories, ron, setCategory } from "@/lib/bf";

const COLS = [["A", "Clienți A", "5.000+ lei / lună"], ["B", "Clienți B", "3.000+ lei / lună"], ["C", "Clienți C", "500+ lei / lună"], ["", "Fără categorie", "sub 500 lei / lună"]];

export default function BFCategories() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { fetchCategories().then(setRows).catch(() => setRows([])); }, []);
  if (!rows) return <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p>;
  const move = (r, cat) => {
    setBusy(r.id);
    setCategory(r.id, cat).then((d) => { setRows((l) => l.map((x) => (x.id === r.id ? { ...x, ...d } : x))); toast.success(`${r.salon} mutat la ${cat ? `clienți ${cat}` : "fără categorie"}`); })
      .catch(() => toast.error("Nu am putut muta salonul")).finally(() => setBusy(""));
  };
  return (
    <div data-testid="bf-categories">
      <p className="st-hint">Categoria se schimbă automat după comenzile din ultimele 30 de zile: A peste 5.000 lei, B peste 3.000 lei, C peste 500 lei. Poți muta tu un salon oricând; la următoarea comandă se recalculează automat.</p>
      <div className="bf-cats">
        {COLS.map(([k, title, hint]) => {
          const list = rows.filter((r) => (r.cat || "") === k);
          return (
            <section key={k || "none"} className={`bf-cats-col is-${k || "none"}`} data-testid={`bf-cats-col-${k || "none"}`}>
              <h4>{title} <em>{list.length}</em></h4>
              <small>{hint}</small>
              <ul>
                {!list.length && <li className="bf-cats-empty">Niciun salon aici.</li>}
                {list.map((r) => (
                  <li key={r.id} data-testid={`bf-cats-row-${r.id}`}>
                    <Link to={`/client/${r.id}`}><b>{r.salon || "Salon"}</b><small>{ron(r.month)} în 30 zile{r.manual ? " · mutat manual" : ""}</small></Link>
                    <div className="bf-cats-move">
                      {busy === r.id ? <Loader2 size={14} className="animate-spin" /> : COLS.filter(([c]) => c !== k).map(([c]) => (
                        <button key={c || "none"} type="button" onClick={() => move(r, c)} data-testid={`bf-cats-move-${r.id}-${c || "none"}`}>{c || "—"}</button>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </div>
  );
}
